import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router";

import { ContentWrapper } from "components/common/Wrappers";

const WarningWrapper = styled.div`
  border-left: 3px solid ${({ theme }) => theme.colors.warning};
  margin-top: 30px;
  padding: 15px;
  text-align: left;
`;

const Link = styled.a`
  color: ${({ theme }) => theme.colors.primary} !important;
  cursor: pointer;
  text-decoration: none;
`;

export const NoPermissions = () => {
  const history = useHistory();
  return <ContentWrapper>
    <WarningWrapper>
      You do not have required permissions to view this page. Click
      <Link onClick={() => history.push("/")}>&nbsp;here&nbsp;</Link>to return to Dashboard.
    </WarningWrapper>
  </ContentWrapper>;
};
